import { useLocation } from 'react-router-dom'
import { queryParamsFromString } from '../url'

// eslint-disable-next-line import/no-unused-modules
export const useSearchParams = (): Record<string, string> => {
  const { search } = useLocation()
  return queryParamsFromString(search)
}
